const React = require('react');
const delay = require('mn-utils/delay');
const formatDate = require('mn-utils/formatDate');
const withState = require('../../../utils/withState');
const KeyboardDatePickerB = require('../KeyboardDatePicker/B');
const ButtonBlack = require('../Button/Black');
const WrapperWithLoading = require('../WrapperWithLoading');


module.exports = withState((setState) => {
  return (state, props) => {
    const {
      dateTo,
      dateFrom,
      urlPrefix,
    } = props;

    function getLink(key) {
      return urlPrefix + key + '?from='
        + Math.floor(dateFrom * 0.001)
        + '&to=' + Math.floor(dateTo * 0.001);
    }
    function getName(key) {
      return 'transactions_'
        + formatDate(dateFrom, 'yyyy-mm-dd-HH-MM') + '_'
        + formatDate(dateTo, 'yyyy-mm-dd-HH-MM') + '.' + key;
    }
    function handleLoading() {
      setState({
        loading: true,
      });
      delay(setState, 2000, [{loading: false}]);
    }


    return (
      <WrapperWithLoading loading={state.loading}>
        <div className="layoutRow">
          <div className="item w(|min)250 mr10">
            <KeyboardDatePickerB
              className="mt20"
              disableFuture
              label="Date from"
              value={dateFrom}
              onChange={props.onChangeDateFrom}
            />
          </div>
          <div className="item w(|min)250 mr10">
            <KeyboardDatePickerB
              className="mt20"
              disableFuture
              label="Date to"
              value={dateTo}
              onChange={props.onChangeDateTo}
            />
          </div>
          <div className="item w(|min)250 mr10">
            <ButtonBlack className="hmin56 mt20"
              onClick={handleLoading}
              target="_blank"
              href={getLink('csv')}
              download={getName('csv')}
            >Download report CSV</ButtonBlack>
          </div>
          <div className="item w(|min)250">
            <ButtonBlack className="hmin56 mt20"
              onClick={handleLoading}
              target="_blank"
              href={getLink('pdf')}
              download={getName('pdf')}
            >Download report PDF</ButtonBlack>
          </div>
        </div>
      </WrapperWithLoading>
    );
  };
});
